import React from "react";

const Section = () => {
  return (
    <section className="bg-violeta-claro p-relative">
      <div className="container">
        <div className="pl-5">
          <div className="section-padding">
            <div className="row row-cols-1">
              <div className="col pr-37">
                <div className="section-title d-flex justify-content-center flex-column align-items-center ta-center">
                  <p className="section-text">¿Cómo participar?</p>
                  <img
                    src="./img/linea-horizontal.svg"
                    alt="vector"
                    style={{ marginLeft: "20px" }}
                  />
                </div>
                <div className="row row-cols-1 row-cols-lg-3 white ta-center">
                  <div className="d-flex gap-20 flex-column align-items-center pb-4">
                    <span className="sirgle" number="1"></span>
                    <p>Realizá un testdrive en un concesionario Kia.</p>
                  </div>
                  <div className="d-flex gap-20 flex-column align-items-center pb-4">
                    <span className="sirgle" number="2"></span>
                    <p>
                      Subí un posteo a tu cuenta de Instagram etiquetando a
                      <span className="fw600"> @kia_argentina</span> con el
                      hashtag <span className="fw600">#RoadToInspiration</span>{" "}
                      y contanos qué te inspira de ir a Qatar con Kia.
                    </p>
                  </div>
                  <div className="d-flex gap-20 flex-column align-items-center pb-4">
                    <span className="sirgle" number="3"></span>
                    <p>
                      Completá el formulario que te dará el concesionario con
                      tus datos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        src="./img/arrow-down.svg"
        alt="Arrow down"
        className="p-absolute arrow-down"
      />
    </section>
  );
};

export default Section;
